import { ErrorInfo, ErrorInfoPresenter } from './error-handler';

export class ErrorToast {
  constructor(public model: ErrorInfo, public detailsPresenter: ErrorInfoPresenter = null) { }
}
